// src/pages/Accounting/Receipts/components/ReviewMode/SuggestedMatch.tsx

import type { MatchedTransaction } from "../../types";
import { PALETTE } from "../../constants";
import { formatCurrency, formatDate } from "../../utils";

interface SuggestedMatchProps {
  matched: MatchedTransaction | undefined;
  isConfirmed: boolean;
  onKeepMatch: () => void;
  onUnmatch: () => void;
  onPickDifferent: () => void;
}

export function SuggestedMatch({
  matched,
  isConfirmed,
  onKeepMatch,
  onUnmatch,
  onPickDifferent,
}: SuggestedMatchProps) {
  return (
    <div
      style={{
        padding: "12px 0",
        borderTop: `1px solid ${PALETTE.lineSoft}`,
        marginTop: 6,
      }}
    >
      <div
        style={{
          fontSize: 11,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: PALETTE.ink2,
          fontWeight: 700,
          marginBottom: 8,
        }}
      >
        {matched ? "Suggested match" : "No match found"}
      </div>

      {matched ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "4px 0 10px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
              <div
                style={{
                  fontSize: 11.5,
                  color: PALETTE.ink3,
                  fontWeight: 500,
                }}
              >
                {formatDate(matched.date)} &middot; {matched.bankName}
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: PALETTE.ink,
                  fontWeight: 600,
                  marginTop: 2,
                }}
              >
                {matched.description}
              </div>
            </div>
            <div
              style={{
                fontSize: 13,
                color: PALETTE.ink,
                fontWeight: 600,
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {formatCurrency(matched.amount, matched.currency)}
            </div>
          </div>
          <div style={{ display: "flex", gap: 14, fontSize: 12 }}>
            <button
              type="button"
              onClick={onKeepMatch}
              style={{
                background: "transparent",
                border: 0,
                padding: 0,
                color: isConfirmed ? PALETTE.tealDark : PALETTE.ink2,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              {isConfirmed ? "\u2713 Match kept" : "Keep match"}
            </button>
            <button
              type="button"
              onClick={onUnmatch}
              style={{
                background: "transparent",
                border: 0,
                padding: 0,
                color: PALETTE.ink3,
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Unmatch
            </button>
            <button
              type="button"
              onClick={onPickDifferent}
              style={{
                background: "transparent",
                border: 0,
                padding: 0,
                color: PALETTE.ink3,
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Pick a different transaction
            </button>
          </div>
        </>
      ) : (
        <div
          style={{
            fontSize: 13,
            color: PALETTE.ink3,
            fontWeight: 500,
            padding: "4px 0 10px",
          }}
        >
          Vela couldn't find a matching bank transaction. You can still approve
          and match it later.
        </div>
      )}
    </div>
  );
}